import {BufferWriter, Writer} from "protobufjs";

import {User} from "../../../domain/model/user";
import {IUserRepository} from "../../../domain/repository/user_repository";

import {api, common} from "../rpc/api";
import {getToken} from "./bind_token";
import {IApiClient} from "../client";

import {UserConvertResponse,} from "./user_api_convert";
import GetMeResponse = api.Me;
import Empty = common.Empty;

class UserAPI implements IUserRepository {
    constructor(readonly apiClient: IApiClient) {
    }

    public getMe(): Promise<User> {
        return new Promise<User>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: Empty = new Empty();
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.UserService/GetMe", token, Empty.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: GetMeResponse = GetMeResponse.decode(binary);
                    // BE=>FE 型変換
                    const resConverted: UserConvertResponse = UserConvertResponse.from(res);
                    const item: User = User.from(resConverted);
                    resolve(item);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

}

const createUserAPI = (apiClient: IApiClient): IUserRepository => {
    return new UserAPI(apiClient);
};

export {createUserAPI};



// WEBPACK FOOTER //
// ./src/infra/api/service/user_api.ts